import { Menu, Tooltip, ActionIcon } from "@mantine/core";
import { IconHistory } from "@tabler/icons-react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useDispatch, useSelector } from "../../../redux/hooks";
import { setNavigatedFromLogbook } from "../../../redux/slices/generatorFeaturesSlice";
import { Button } from "../../shared/Button/Button";
interface Props {
  lbid?: string;
  preview?: boolean;
  previewAvailable?: boolean;
  icon?: boolean;
  summaryAction?: boolean;
  disabled?: boolean;
}
const HistoricalSnapshotButton = ({
  lbid,
  preview: previewOverwrite,
  previewAvailable: previewAvailableOverwrite,
  icon,
  summaryAction,
  disabled,
}: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { logbookId, aid } = useParams();
  const [searchParams] = useSearchParams();
  const { previewAvailable } = useSelector(state => state.generatorSlice);

  const preview = previewOverwrite ?? searchParams.get("preview");

  if (!preview)
    if (!previewAvailable) if (!previewAvailableOverwrite) return null;

  const handleNavigate = () => {
    if (preview && lbid && aid) {
      navigate(`/historical-snapshot/${lbid}/${aid}`);
    } else if (logbookId || lbid) {
      navigate(`/historical-snapshot/${logbookId || lbid}`);
    } else {
      return;
    }
    dispatch(setNavigatedFromLogbook(true));
  };
  if (previewOverwrite) {
    if (summaryAction) {
      return (
        <Tooltip withArrow label="Historical Snapshot">
          <ActionIcon
            p={4}
            size={32}
            disabled={disabled}
            variant="outline"
            color="blue"
            onClick={handleNavigate}>
            <IconHistory />
          </ActionIcon>
        </Tooltip>
      );
    }
    return (
      <Button onClick={handleNavigate} size="xs">
        {icon ? <IconHistory size={16} /> : "Historical Snapshot"}
      </Button>
    );
  }
  return (
    <Menu.Item onClick={handleNavigate} leftSection={<IconHistory size={20} />}>
      {icon ? "" : "Historical Snapshot"}
    </Menu.Item>
  );
};
export default HistoricalSnapshotButton;
